import * as Monitaro from '@/infrastructure/network/Monitaro/schema/models'
import { APIRequest } from '@/infrastructure/network/APIRequest'
import { HTTPMethod } from '@/infrastructure/network/types'

/**
 * Google OAuth ログイン
 *
 * Googleアカウントでのログイン
 */
export class PostGoogleLogin implements APIRequest<Monitaro.GoogleLoginResponse> {
  response: Monitaro.GoogleLoginResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.POST
  constructor() {
    this.path = `/oauth/google/login`
  }
}

/**
 * Google OAuth Callback
 *
 * Googleアカウントでのログイン
 */
export class PostGoogleCallback implements APIRequest<Monitaro.GoogleCallbackResponse> {
  response: Monitaro.GoogleCallbackResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.POST
  params: any
  constructor(params: any) {
    this.params = params
    this.path = `/oauth/google/callback`
  }
}
